import React, { Component } from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import { withStateHandlers } from 'recompose';

import {
  Button,
  ButtonToolbar,
  Clearfix,
  Modal,
  FormGroup,
  FormControl,
  ControlLabel,
  Form,
} from 'react-bootstrap';

import { tryHandleGraphQLError } from '../../../../utils/graphQLErrorHandlers';

export const denyPerDiemModalPropTypes = {
  openDenyModal: PropTypes.func.isRequired,
  closeDenyModal: PropTypes.func.isRequired,
  showDenyModal: PropTypes.bool.isRequired,
};


export const withDenyPerDiemModalState = withStateHandlers(
  (props) => { return { showDenyModal: false }; },
  {
    openDenyModal: (state, props) => {
      return () => { return { showDenyModal: true }; };
    },
    closeDenyModal: (state, props) => {
      return () => { return { showDenyModal: false }; };
    },
  },
);


const propTypes = exact({
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  denyPerDiemAction: PropTypes.func.isRequired,
});


export class DenyPerDiemModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      reason: '',
      errorMessage: '',
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleDenyPerDiem = this.handleDenyPerDiem.bind(this);
    this.resetAndClose = this.resetAndClose.bind(this);
  }

  handleChange(e) {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  }

  async handleDenyPerDiem(reason) {
    const { denyPerDiemAction } = this.props;
    try {
      await denyPerDiemAction(reason);
      this.resetAndClose();
    } catch (e) {
      const graphQLErrorMessage = tryHandleGraphQLError(e);
      this.setState({ errorMessage: graphQLErrorMessage });
    }
  }

  resetAndClose() {
    const { onHide } = this.props;
    this.setState({ reason: '' });
    onHide();
  }


  render() {
    const { show, onHide } = this.props;
    const { reason, errorMessage } = this.state;
    return (
      <Modal show={show} onHide={onHide}>
        <Modal.Header closeButton>
          <Modal.Title>Deny Per Diem Request</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Clearfix>
            <Form>
              <FormGroup>
                <ControlLabel>Enter in a reason for denying Per Diem Request</ControlLabel>
                <FormControl
                  onChange={this.handleChange}
                  type="text"
                  value={reason}
                  name="reason"
                />
              </FormGroup>
              <ButtonToolbar className="pull-right">
                <Button
                  bsStyle="warning"
                  onClick={this.resetAndClose}
                >
                  Close
                </Button>
                <Button
                  disabled={reason.length === 0}
                  bsStyle="primary"
                  onClick={() => { return this.handleDenyPerDiem(reason); }}
                >
                  Confirm
                </Button>
              </ButtonToolbar>
            </Form>
          </Clearfix>
          {errorMessage && <span className="form-error">{errorMessage}</span>}
        </Modal.Body>
      </Modal>
    );
  }
}

DenyPerDiemModal.propTypes = propTypes;

export default DenyPerDiemModal;
